/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { FileManagementListFileForMemberResponse } from "./FileManagementListFileForMemberResponse";

export type FileManagementListFileForMemberResponseApiRespoonse = {
  data?: FileManagementListFileForMemberResponse;
  status?: FileManagementListFileForMemberResponseApiRespoonse.status;
  message?: string;
  errors?: Record<string, Array<string>>;
};

export namespace FileManagementListFileForMemberResponseApiRespoonse {
  export enum status {
    SUCCESS = "success",
    ERROR = "error",
  }
}
